import { useMaxWidthBreakpoint } from '@sevenrooms/ui-kit/hooks'

export function useOtherAvailabilitySectionBaseSpacing() {
  const isMobile = useMaxWidthBreakpoint('s')
  return isMobile ? 'sm' : 'lm'
}
